import { render, staticRenderFns } from "./SectionDetailForCession.vue?vue&type=template&id=0feed524&"
import script from "./SectionDetailForCession.vue?vue&type=script&lang=js&"
export * from "./SectionDetailForCession.vue?vue&type=script&lang=js&"
import style0 from "./SectionDetailForCession.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SectionDetailForCession.vue"
export default component.exports